<div class="manage-role-shell">
  @if (mobileSidebarOpen) {
    <button type="button" class="manage-role-shell__backdrop" aria-label="Close sidebar" (click)="closeMobileSidebar()"></button>
  }

  <aside
    class="manage-role-shell__sidebar"
    [class.manage-role-shell__sidebar--collapsed]="sidebarCollapsed"
    [class.manage-role-shell__sidebar--mobile-open]="mobileSidebarOpen"
  >
    <app-dashboard-sidebar [collapsed]="sidebarCollapsed" />
  </aside>

  <div class="manage-role-shell__content">
    <app-dashboard-header
      [title]="''"
      [subtitle]="''"
      [user]="user"
      [currentTime]="''"
      (menuToggle)="handleMenuToggle()"
    />

    <main class="manage-role-page">
      <section class="manage-role-page__heading">
        <div class="manage-role-page__heading-copy">
          <h2 class="app-title-serif">Manage Role</h2>
        </div>

        <button type="button" class="app-button app-button--primary manage-role-page__add-button" (click)="openAddRoleModal()">
          <span class="manage-role-page__add-icon">+</span>
          <span>Add New Role</span>
        </button>
      </section>

      <section class="manage-role-page__filters app-card">
        <form class="manage-role-filters" [formGroup]="filterForm">
          <label class="app-form-field manage-role-filters__field">
            <span class="app-form-label">Search</span>
            <div class="manage-role-filters__search">
              <span class="manage-role-filters__search-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="11" cy="11" r="7"></circle>
                  <path d="m20 20-3.5-3.5"></path>
                </svg>
              </span>
              <input class="app-form-input manage-role-filters__search-input" type="text" placeholder="Search" formControlName="search" />
            </div>
          </label>

          <div >
            <button
              type="button"
              class="app-button app-button--secondary equal app-filter-actions__button"
              [disabled]="isLoading"
              (click)="clearFilters()"
            >
              Clear
            </button>
          </div>
        </form>
      </section>

      <section class="manage-role-page__table app-card">
        <div class="manage-role-page__table-wrap app-table-scroll">
          <table class="manage-role-table">
            <thead>
              <tr>
                <th>S.No.</th>
	                <th><button type="button" class="manage-sort-button" (click)="toggleSort('display_name')" [attr.aria-label]="'Sort by Name'"><span>Name</span><svg class="manage-sort-icon" [class.manage-sort-icon--ascending]="isSortAscending('display_name')" [class.manage-sort-icon--descending]="isSortDescending('display_name')" viewBox="0 0 12 16" aria-hidden="true"><path class="manage-sort-icon-up" d="M6 1 2 5h8L6 1Z"></path><path class="manage-sort-icon-down" d="m2 11 4 4 4-4H2Z"></path></svg></button></th>
	                <th>Description</th>
                <th>Users</th>
                <th>Menus</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              @if (isLoading) {
                <tr>
		                  <td colspan="6" class="manage-role-page__empty-state">Loading roles...</td>
                </tr>
              } @else if (filteredRoles.length) {
                @for (item of filteredRoles; track trackByRoleId($index, item)) {
                  <tr>
	                    <td>{{ item.serial_no }}</td>
		                    <td>{{ item.display_name }}</td>
                    <td>{{ item.description || '-' }}</td>
                    <td>{{ item.user_count }}</td>
                    <td>
                      <button type="button" class="app-button app-button--secondary manage-role-page__rights-button" (click)="openRightsModal(item)">
                        {{ getRoleSummary(item) }}
                      </button>
                    </td>
                    <td>
                      <div class="manage-role-page__actions">
                        <div class="app-row-action-menu">
                          <details class="app-row-action-menu__details">
                            <summary class="app-row-action-menu__toggle" aria-label="Open role actions">
                              <span class="app-row-action-menu__dots" aria-hidden="true">
                                <span></span>
                                <span></span>
                                <span></span>
                              </span>
                            </summary>
                            <div class="app-row-action-menu__dropdown">
                              <button type="button" class="app-row-action-menu__item app-row-action-menu__item--view" (click)="openViewRoleModal(item)">
                                <span class="app-row-action-menu__icon app-row-action-menu__icon--view" aria-hidden="true">
                                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M2.5 12s3.5-6.5 9.5-6.5S21.5 12 21.5 12s-3.5 6.5-9.5 6.5S2.5 12 2.5 12Z"></path>
                                    <circle cx="12" cy="12" r="2.8"></circle>
                                  </svg>
                                </span>
                                <span>View</span>
                              </button>
                              <button type="button" class="app-row-action-menu__item app-row-action-menu__item--edit" (click)="openEditRoleModal(item)">
                                <span class="app-row-action-menu__icon app-row-action-menu__icon--edit" aria-hidden="true">
                                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="m4 20 4.5-1 11-11a2.1 2.1 0 0 0-3-3l-11 11L4 20Z"></path>
                                    <path d="m13.5 6.5 4 4"></path>
                                  </svg>
                                </span>
                                <span>Edit</span>
                              </button>
                              <button type="button" class="app-row-action-menu__item app-row-action-menu__item--danger app-row-action-menu__item--delete" (click)="openDeleteRoleModal(item)">
                                <span class="app-row-action-menu__icon app-row-action-menu__icon--delete" aria-hidden="true">
                                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M3 6h18"></path>
                                    <path d="M8 6V4.5A1.5 1.5 0 0 1 9.5 3h5A1.5 1.5 0 0 1 16 4.5V6"></path>
                                    <path d="M6 6l1 14a1.5 1.5 0 0 0 1.5 1.5h8A1.5 1.5 0 0 0 18 20L19 6"></path>
                                    <path d="M10 10v6"></path>
                                    <path d="M14 10v6"></path>
                                  </svg>
                                </span>
                                <span>Delete</span>
                              </button>
                            </div>
                          </details>
                        </div>
                      </div>
                    </td>
                  </tr>
                }
              } @else {
                <tr>
	                  <td colspan="6" class="manage-role-page__empty-state">No roles found</td>
                </tr>
              }
            </tbody>
          </table>
        </div>

        @if (canShowPagination()) {
          <div class="manage-role-page__pagination">
            <div class="manage-role-page__pagination-summary">
              <span>{{ getPaginationLabel() }}</span>
            </div>

            <div class="manage-role-page__pagination-actions">
              <button type="button" class="app-button app-button--secondary manage-role-page__pagination-button" [disabled]="pagination.page_no <= 1 || isLoading" (click)="goToPreviousPage()">
                Previous
              </button>

              <div class="manage-role-page__pagination-pages" aria-label="Pagination pages">
                @for (page of getPaginationItems(); track $index) {
                  @if (page === -1) {
                    <span class="manage-role-page__pagination-ellipsis" aria-hidden="true">...</span>
                  } @else {
                    <button
                      type="button"
                      class="manage-role-page__pagination-page"
                      [class.manage-role-page__pagination-page--active]="pagination.page_no === page"
                      [disabled]="isLoading"
                      (click)="goToPage(page)"
                    >
                      {{ page }}
                    </button>
                  }
                }
              </div>

              <button type="button" class="app-button app-button--secondary manage-role-page__pagination-button" [disabled]="pagination.page_no >= pagination.total_pages || isLoading || pagination.total_pages === 0" (click)="goToNextPage()">
                Next
              </button>
            </div>

            <label class="manage-role-page__pagination-size">
              <span class="manage-role-page__pagination-size-label">Rows per page</span>
              <select class="app-form-select manage-role-page__pagination-select" [formControl]="pageSizeControl">
                @for (size of pageSizeOptions; track size) {
                  <option [ngValue]="size">{{ size }}/Page</option>
                }
              </select>
            </label>
          </div>
        }
      </section>
    </main>
  </div>

  @if (roleModalOpen) {
    <div class="app-modal-backdrop">
      <dialog class="app-modal manage-role-modal" open>
        <div class="manage-role-modal__header">
          <div>
            <h3 class="app-title-serif">{{ modalMode === 'edit' ? 'Edit Role' : modalMode === 'view' ? 'View Role' : 'Add New Role' }}</h3>
          </div>

          <button type="button" class="app-button app-button--icon manage-role-modal__close" aria-label="Close modal" (click)="closeRoleModal()">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round">
              <path d="M6 6 18 18"></path>
              <path d="M18 6 6 18"></path>
            </svg>
          </button>
        </div>

        <form [formGroup]="roleForm" (ngSubmit)="saveRole()">
          <div class="manage-role-modal__body">
            <div class="manage-role-modal__grid">
		              <label class="app-form-field">
		                <span class="app-form-label">Role Name <span class="manage-role-modal__required">*</span></span>
		                <input class="app-form-input" type="text" placeholder="e.g., ADMIN" formControlName="role_name" />
	                @if (isRequiredFieldInvalid('role_name')) {
	                  <section class="app-form-error">Role name is required</section>
	                }
	                @if (isRoleNamePatternInvalid()) {
	                  <section class="app-form-error">Role name can contain only letters, numbers, and underscore</section>
	                }
		              </label>

	              <label class="app-form-field">
	                <span class="app-form-label"> Display Name <span class="manage-role-modal__required">*</span></span>
	                <input class="app-form-input" type="text" placeholder="e.g., Admin User" formControlName="display_name" />
	                @if (isRequiredFieldInvalid('display_name')) {
	                  <section class="app-form-error"> Display Name is required</section>
	                }
	              </label>

              <label class="app-form-field">
                <span class="app-form-label">Description</span>
                <input class="app-form-input" type="text" placeholder="Optional description" formControlName="description" />
              </label>
            </div>
          </div>

          <div class="manage-role-modal__footer">
            <button type="button" class="app-button app-button--secondary" (click)="closeRoleModal()">Cancel</button>
            @if (modalMode !== 'view') {
              <button type="submit" class="app-button app-button--primary">Save</button>
            }
          </div>
        </form>
      </dialog>
    </div>
  }

  @if (rightsModalOpen && selectedRole) {
    <div class="app-modal-backdrop">
      <dialog class="app-modal manage-role-rights-modal" open>
        <div class="manage-role-rights-modal__header">
          <div>
            <h3 class="app-title-serif">Manage Role Menus</h3>
	            <p>{{ selectedRole.display_name }}</p>
          </div>

          <button type="button" class="app-button app-button--icon manage-role-rights-modal__close" aria-label="Close modal" (click)="closeRightsModal()">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round">
              <path d="M6 6 18 18"></path>
              <path d="M18 6 6 18"></path>
            </svg>
          </button>
        </div>

        <div class="manage-role-rights-modal__body">
          <div class="manage-role-rights-modal__bulk-actions">
            <label class="manage-role-rights-modal__bulk-toggle">
              <input type="checkbox" [checked]="areAllReadSelected()" (change)="toggleAllRead($any($event.target).checked)" />
              <span>Select all read</span>
            </label>

            <label class="manage-role-rights-modal__bulk-toggle">
              <input type="checkbox" [checked]="areAllWriteSelected()" (change)="toggleAllWrite($any($event.target).checked)" />
              <span>Select all write</span>
            </label>

            <label class="manage-role-rights-modal__bulk-toggle">
              <input type="checkbox" [checked]="updateExistingUsers" (change)="updateExistingUsers = $any($event.target).checked" />
              <span>Update existing users</span>
            </label>
          </div>

          <div class="manage-role-rights-modal__table-wrap app-table-scroll">
            <table class="manage-role-rights-table">
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Menu Name</th>
                  <th>Read</th>
                  <th>Write</th>
                </tr>
              </thead>
              <tbody>
                @for (item of rightsDraft; track trackByRightId($index, item)) {
                  <tr>
                    <td>{{ item.serial_no }}</td>
                    <td>
                      <div
                        class="manage-role-rights-table__menu-name"
                        [class.manage-role-rights-table__menu-name--child]="isChildRight(item)"
                        [style.--menu-depth]="item.depth"
                      >
                        <span class="manage-role-rightFsyncRoleAssignmentControlss-table__branch" aria-hidden="true"></span>
                        <div class="manage-role-rights-table__menu-copy">
                          <span class="manage-role-rights-table__menu-title">{{ item.menu_name }}</span>
                          @if (item.parent_menu_name) {
                            <span class="manage-role-rights-table__menu-parent">Child of {{ item.parent_menu_name }}</span>
                          }
                        </div>
                      </div>
                    </td>
                    <td>
                      <label class="manage-role-rights-table__check">
                        <input type="checkbox" [checked]="item.is_read" (change)="onReadChange(item, $any($event.target).checked)" />
                        <span>Read</span>
                      </label>
                    </td>
                    <td>
                      <label class="manage-role-rights-table__check">
                        <input type="checkbox" [checked]="item.is_write" (change)="onWriteChange(item, $any($event.target).checked)" />
                        <span>Write</span>
                      </label>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>

        <div class="manage-role-rights-modal__footer">
          <button type="button" class="app-button app-button--secondary" (click)="closeRightsModal()">Cancel</button>
          <button type="button" class="app-button app-button--primary" (click)="saveRights()">Submit</button>
        </div>
      </dialog>
    </div>
  }

  @if (deleteModalOpen && selectedRole) {
    <div class="app-modal-backdrop">
      <section class="app-modal app-modal--compact manage-role-delete">
        <div class="manage-role-delete__header">
          <div class="manage-role-delete__icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M10 11v5"></path>
              <path d="M14 11v5"></path>
              <path d="M3 6h18"></path>
              <path d="M8 6V4.5A1.5 1.5 0 0 1 9.5 3h5A1.5 1.5 0 0 1 16 4.5V6"></path>
              <path d="M6 6l1 14a1.5 1.5 0 0 0 1.5 1.5h8A1.5 1.5 0 0 0 18 20L19 6"></path>
            </svg>
          </div>
          <div>
            <h3 class="app-title-serif">Delete Role</h3>
            <p>This action will deactivate the role</p>
          </div>
        </div>

        <p class="manage-role-delete__copy">
	          Are you sure you want to delete <strong>{{ selectedRole.display_name }}</strong>?
        </p>

        <div class="manage-role-delete__footer">
          <button type="button" class="app-button app-button--secondary" (click)="closeDeleteModal()">Cancel</button>
          <button type="button" class="app-button app-button--danger" (click)="confirmDelete()">Confirm Delete</button>
        </div>
      </section>
    </div>
  }
</div>
